import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CurrencyCell from './CurrencyCell';
import DateCell from "components/ContactList/bodyCells/DateCell";
import FunctionalCell from './FunctionalCell';

import ColumnClassNamesType from 'propTypes/columnClassNamesType';
import LinkCell from './LinkCell';
import BulkCheckboxCell from './BulkCheckboxCell';

const BodyCell = (props) => {
  const { contact, type, value, columnClassNames } = props;

  if (type === 'link') {
    return <LinkCell {...props} />;
  } else if (type === 'bulkCheckbox') {
    return <BulkCheckboxCell {...props} />;
  }

  if (typeof value === 'function') {
    return <FunctionalCell contact={contact} value={value} {...props}/>;
  }

  switch (type) {
    case 'currency':
      return <CurrencyCell {...props} />;
    case 'date':
      return <DateCell {...props}/>;
    default:
      return <td className={classNames(columnClassNames)}>{contact[value]}</td>;
  }
};

BodyCell.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string
  }),
  type: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string, PropTypes.func
  ]),
  columnClassNames: ColumnClassNamesType
};

BodyCell.defaultProps = {
  contact: {},
  type: '',
  value: '',
  columnClassNames: []
};

export default BodyCell;
